import { SDKVoiceFacade, getSDK } from 'modules/sdk/lib';

import { useSettingsStore } from '../store';
import { subscribe as librarySubscribe } from './library';
import { subscribe as listeningSubscribe } from './listening';
import { subscribe as speedSubscribe } from './speed';
import { subscribe as voicesSubscribe } from './voices';

type StoreWithHydration = {
  waitForInitialHydration: () => Promise<void>;
};

export const subscribeAll = async () => {
  const cleanupFunctions: (() => void)[] = [];

  if ('waitForInitialHydration' in useSettingsStore) {
    await (useSettingsStore as StoreWithHydration).waitForInitialHydration();
  }

  await getSDK();
  await SDKVoiceFacade.singleton.getAllVoices(true);

  cleanupFunctions.push(librarySubscribe());
  cleanupFunctions.push(listeningSubscribe());
  cleanupFunctions.push(speedSubscribe());
  cleanupFunctions.push(voicesSubscribe());

  return () => {
    cleanupFunctions.forEach(fn => fn());
  };
};
